import { lazy } from 'react';
import { Route } from 'react-router-dom';

import GatedRoute from '~/components/GatedRoute';
import { useEntitlements } from '~/hooks/account';
import { ConfigType } from '~/pages/configurations/Show/ConfigurationPanelFactory';

import { settingsRoutes } from '../settingsRoutes';
import {
  PageAPIKeys,
  PageAPILogs,
  PageAPIUsage,
  PageGeneralAccount,
  PageGeneralBilling,
  PageGeneralNotifications,
  PageGeneralTeams,
  PageTeamGeneral,
  PageTeamUsers,
} from '.';

const Disconnected = lazy(() =>
  import('~/pages/configurations/Show/Disconnected'),
);
const ConfigurationPanelFactory = lazy(() =>
  import('~/pages/configurations/Show/ConfigurationPanelFactory'),
);

const {
  settingsIndexRoute,
  generalAccountRoute,
  generalTeamsRoute,
  generalNotificationsRoute,
  generalBillingRoute,
  teamGeneralRoute,
  teamUsersRoute,
  teamNotificationsRoute,
  // productsTargetMarketRoute,
  // productsVisitorReportRoute,
  apiKeysRoute,
  apiLogsRoute,
  apiUsageRoute,
} = settingsRoutes;

export const PageSettingsIndex = () => {
  const {
    hasAccessSettingsApi,
    hasAccessSettingsApiUsage,
    hasAccessSettingsConnectedServices,
    hasAccessSettingsTeamUsers,
    loading,
  } = useEntitlements();

  return (
    <>
      {hasAccessSettingsConnectedServices ? (
        <Route
          exact
          path="/settings/configuration/:service/connect"
          render={({
            match: {
              params: { service },
            },
          }) => <Disconnected service={service} />}
        />
      ) : null}

      {hasAccessSettingsConnectedServices ? (
        <Route
          path="/settings/configuration/:service"
          render={({
            match: {
              params: { service },
            },
          }) => <ConfigurationPanelFactory config={service as ConfigType} />}
        />
      ) : null}

      <Route component={PageGeneralAccount} exact path={settingsIndexRoute} />

      <Route component={PageGeneralAccount} exact path={generalAccountRoute} />

      <Route component={PageGeneralTeams} exact path={generalTeamsRoute} />

      <Route
        component={PageGeneralNotifications}
        exact
        path={generalNotificationsRoute}
      />

      <Route component={PageGeneralBilling} exact path={generalBillingRoute} />

      <Route component={PageTeamGeneral} exact path={teamGeneralRoute} />

      <GatedRoute
        component={PageTeamUsers}
        exact
        hasAccess={hasAccessSettingsTeamUsers}
        loading={loading}
        path={teamUsersRoute}
      />

      <Route
        component={PageGeneralNotifications}
        exact
        path={teamNotificationsRoute}
      />

      <GatedRoute
        component={PageAPIKeys}
        exact
        hasAccess={hasAccessSettingsApi}
        loading={loading}
        path={apiKeysRoute}
      />
      <GatedRoute
        component={PageAPILogs}
        exact
        hasAccess={hasAccessSettingsApi}
        loading={loading}
        path={apiLogsRoute}
      />
      <GatedRoute
        component={PageAPIUsage}
        exact
        hasAccess={hasAccessSettingsApiUsage}
        loading={loading}
        path={apiUsageRoute}
      />
    </>
  );
};
